module.exports = __webpack_public_path__ + "static/media/hotel-3.e1372199.jpg";